<nav id="sidenav" class="sidenav" aria-label="Main Navigation">
  <button class="closebtn" aria-label="Close Navigation" (click)="toggleNav()">&times;</button>

  <div class="link-container">
    <img src="../assets/images/exl_logo_rgb_wht_rev.png" alt="EXL Company Logo" class="brandExl" />

    <a 
      id="sidenav-home" 
      routerLink="/home/landing-page" 
      routerLinkActive="active"  
      (click)="navigateMenu('orders')">
      <i class="pi pi-book"></i>
      Orders List
    </a>

    <ng-container *ngIf="!isExternalUser">
      <button
        id="sidenav-account"
        class="submenu-toggle"
        type="button"
        [attr.aria-expanded]="activeSubmenu === 'account'"
        [attr.aria-controls]="'account-submenu'"
        (click)="toggleSubmenu('account')"
      >
        <i class="pi pi-user"></i> Account Manager
      </button>

      <div *ngIf="activeSubmenu === 'account'" id="account-submenu" class="submenu">
        <a href="javascript:void(0);" (click)="navigateMenu('account-contacts')">Contacts</a>
      </div>

      <button
        id="sidenav-client"
        class="submenu-toggle"
        type="button"
        [attr.aria-expanded]="activeSubmenu === 'client'"
        [attr.aria-controls]="'client-submenu'"
        (click)="toggleSubmenu('client')"
      >
        <i class="pi pi-users"></i> Client Manager
      </button>

      <div *ngIf="activeSubmenu === 'client'" id="client-submenu" class="submenu">
        <a href="javascript:void(0);" (click)="navigateMenu('client-contacts')">Contact</a>
      </div>
    </ng-container>
  </div>
</nav>
